const WORKFLOW_ANNOTATION = "github.com/workflows";
const GITHUB_ANNOTATION = "github.com/project-slug";

export { GITHUB_ANNOTATION, WORKFLOW_ANNOTATION };
//# sourceMappingURL=annotations.esm.js.map
